import { sortBy } from '../components/sort-by'
import { toggleDataActive } from '../components/toggle-data-active'
import '../scss/collection.scss'
import '../components/filter-range'

sortBy()

toggleDataActive(
  '#filter-open-js',
  '#filter',
  {
    overlay: true,
    closeSelector: '.filter-close-js'
  }
)